<app-breadcrumb [master]="'ASF360'" [parentName]="'Posty'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-post-details-view *ngIf="!modify " [post]="post" (modifyClicked)="modify = true" ></app-post-details-view>
    <app-post-add *ngIf="modify" [post]="post" (closeModification)="modify = false; loadPost()" ></app-post-add>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [post]="post"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
